import React, { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import { connect } from "react-redux";
import moment from "moment";

function PreviewPositionsGroupSitePublisher({
  dataSitePublisher,
  startDate,
  endDate,
  nameCategory,
}) {
  const [
    showModalPositionsOnCategoryUserSitePublisher,
    setShowModalPositionsOnCategoryUserSitePublisher,
  ] = useState(false);

  const handleCloseModalPositionsOnCategoryUserSitePublisher = () =>
    setShowModalPositionsOnCategoryUserSitePublisher(false);
  const handleShowModalPositionsOnCategoryUserSitePublisher = () =>
    setShowModalPositionsOnCategoryUserSitePublisher(true);

  const popover = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>
        نمایش جایگاه های انتخاب شده
      </span>
    </Tooltip>
  );

  const calculatePriceSite = (sitePublisherData) => {
    let pricePage = 0;

    for (let pageID in sitePublisherData) {
      if (pageID === "url") {
        continue;
      }
      pricePage += sitePublisherData[pageID].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const getCountPositionsOnSitePublisherData = (sitePublisherData) => {
    if (!sitePublisherData) {
      return 0;
    }
    let countPositions = 0;
    for (const keySitePublisher in sitePublisherData) {
      const sitePublisher = sitePublisherData[keySitePublisher];
      for (const key in sitePublisher) {
        if (key == "url") {
          continue;
        }
        const pageInSitePublisher = sitePublisher[key];
        countPositions += pageInSitePublisher.positions.length;
      }
    }
    return countPositions;
  };

  const generatePositionBoxThatDoseNotExist = (positions) => {
    return positions.map((position, index) => {
      return (
        <div
          key={index}
          className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
        >
          <div className="bg-primary">
            <div className="p-2 d-flex">
              <div className="align-items-center justify-content-center d-flex flex-grow-1">
                <span>اطلاعات جایگاه</span>
                <span className="px-2">-</span>
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    position.tagHtmlID.replace(
                      process.env.REACT_APP_PREFIX_POSITION_TAG_HTML_ID,
                      ""
                    )
                  )}
                </span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                پرداختی شما
              </div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(position.price)
                  )}
                </span>

                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tagHtmlID}
            </div>
          </div>
        </div>
      );
    });
  };

  const showPositionOnCategoryUserSitePublisherOnModalBody = () => {
    if (!Object.entries(dataSitePublisher).length) {
      return (
        <p className="text-center alert alert-warning">
          شما هیچ هیچگاهی انتخاب نکرده اید
        </p>
      );
    }

    const groupUserSitePublisherDataSites = dataSitePublisher;

    let tagCollection = [];

    for (const sitePublisherID in groupUserSitePublisherDataSites) {
      const sitePublisherData =
        groupUserSitePublisherDataSites[sitePublisherID];
      tagCollection.push(
        <div className="py-2">
          <div
            className="border border-2 border-warning bg-warning rounded"
            style={{ height: "5px" }}
          ></div>
          <span>سایت : </span>
          <span>
            <a target="_blank" href={sitePublisherData.url}>
              {sitePublisherData.url}
            </a>
          </span>
          <span className="pr-1">-</span>
          <span className="pr-1">قیمت سایت : </span>
          <span className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                calculatePriceSite(sitePublisherData)
              )
            )}
          </span>
          <span className="pr-1"> تومان</span>
        </div>
      );
      for (const sitePublisherID in sitePublisherData) {
        if (sitePublisherID === "url") {
          continue;
        }
        const pageData = sitePublisherData[sitePublisherID];
        tagCollection.push(
          <>
            <div className="d-flex">
              <div>عنوان صفحه : </div>
              <div>{pageData.title}</div>
              <div className="pr-1">-</div>
              <div className="pr-1">قیمت صفحه :</div>
              <div className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(pageData.price)
                )}
              </div>
              <div className="pr-1"> تومان</div>
            </div>
            <div className="container-fluid" id="select-position-container">
              <div className="row">
                {pageData.positions_report
                  ? generatePositionBox(pageData.positions_report)
                  : generatePositionBoxThatDoseNotExist(pageData.positions)}
              </div>
            </div>
          </>
        );
      }
    }

    return (
      <>
        {startDate && (
          <div className="table-responsive py-2">
            <table className="table table-hilite tbl-td-white-space table-hover m-0  ">
              <thead>
                <tr>
                  <td
                    colspan="2"
                    class="text-center"
                    style={{ borderRadius: "25px 25px 0px 0px" }}
                  >
                    <b>اطلاعات گروه نمایش دهنده کاربر</b>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>نام گروه </td>
                  <td>{nameCategory}</td>
                </tr>
                <tr>
                  <td>تاریخ شروع</td>
                  <td className="ltr">
                    {helpersNumbers.toPersianNum(startDate)} ۰۰:۰۰
                  </td>
                </tr>
                <tr className="ltr">
                  <td>تاریخ پایان</td>
                  <td>{helpersNumbers.toPersianNum(endDate)} ۲۳:۵۹</td>
                </tr>

                <tr>
                  <td>تعداد سایت انتخاب شده</td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      Object.keys(dataSitePublisher).length
                    )}
                  </td>
                </tr>

                <tr>
                  <td>تعداد جایگاه انتخاب شده</td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      getCountPositionsOnSitePublisherData(dataSitePublisher)
                    )}
                  </td>
                </tr>

                <tr>
                  <td>تعداد شبانه روز گروه نمایش دهنده</td>
                  <td>
                    <span>
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          moment(
                            helpersTime.convertJalaliToGregorian(endDate)
                          ).diff(
                            helpersTime.convertJalaliToGregorian(startDate),
                            "days"
                          ) + 1
                        )
                      )}
                    </span>
                    <span className="pr-2">شبانه روز</span>
                  </td>
                </tr>

                <tr>
                  <td>مبلغ گروه در یک شبانه روز</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          getPriceCategoryUserSitePublisher(dataSitePublisher)
                        )
                      )}
                    </span>
                    <span className="pr-2">تومان</span>
                  </td>
                </tr>

                <tr>
                  <td>مبلغ گروه نمایش دهنده</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          (moment(
                            helpersTime.convertJalaliToGregorian(endDate)
                          ).diff(
                            helpersTime.convertJalaliToGregorian(startDate),
                            "days"
                          ) +
                            1) *
                            getPriceCategoryUserSitePublisher(dataSitePublisher)
                        )
                      )}
                    </span>
                    <span className="pr-1">تومان</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {tagCollection}
      </>
    );
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const generatePositionBox = (positions) => {
    return positions.map((position, index) => {
      return (
        <div
          key={index}
          className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
        >
          <div className="bg-primary">
            <div className="p-2 d-flex">
              <div className="align-items-center justify-content-center d-flex flex-grow-1">
                <span>اطلاعات جایگاه</span>
                <span className="px-2">-</span>
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    position.tag_html_id.replace(
                      process.env.REACT_APP_PREFIX_POSITION_TAG_HTML_ID,
                      ""
                    )
                  )}
                </span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">اندازه</div>
              <div className="py-2 w-50 text-center">
                <span className="letter-spacing-finance-number" dir="ltr">
                  {helpersNumbers.toPersianNum(position.size.replace("-", "×"))}
                </span>
                <span className="pr-2">پیکسل</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ظرفیت کل</div>
              <div className="py-2 w-50 text-center">
                {helpersNumbers.toPersianNum(position.count)}
                <span className="pr-2">بنر</span>
              </div>
            </div>
            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم شما</div>
              <div className="py-2 w-50 text-center">
                {helpersNumbers.toPersianNum(1)}
                <span className="pr-2">بنر</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">ارزش کل</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(position.base_price)
                  )}
                </span>
                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className=" d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                پرداختی شما
              </div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(position.price)
                  )}
                </span>

                <span className="pr-2">تومان</span>
              </div>
            </div>

            <div className="px-2 d-flex border-top">
              <div className="py-2 w-50 text-center border-left">سهم نمایش</div>
              <div className="py-2 w-50 text-center ">
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    Math.floor((1 / position.count) * 100)
                  )}
                </span>
                <span className="pr-2">درصد</span>
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <OverlayTrigger
        trigger="hover"
        rootClose
        placement="top"
        overlay={popover}
      >
        <div
          className="position-fixed"
          id="preview-positions-group-site-publisher"
        >
          <span
            className="btn btn-primary rounded-circle"
            onClick={() => {
              handleShowModalPositionsOnCategoryUserSitePublisher();
            }}
          >
            <i className="fa fa-info"></i>
          </span>
        </div>
      </OverlayTrigger>

      <Modal
        size="lg"
        show={showModalPositionsOnCategoryUserSitePublisher}
        onHide={handleCloseModalPositionsOnCategoryUserSitePublisher}
      >
        <Modal.Body>
          {showPositionOnCategoryUserSitePublisherOnModalBody()}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="btn btn-warning"
            onClick={handleCloseModalPositionsOnCategoryUserSitePublisher}
          >
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    nameCategory: state.categoryUserSitePublisher.name_category,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

export default connect(mapStateToProps, {})(PreviewPositionsGroupSitePublisher);
